import React, { useCallback, useEffect, useState } from "react";

import { useDropzone } from "react-dropzone";

import { Box, Flex, Text, Grid, Image, Button } from "atoms";
import UploadIcon from "assets/img/upload.png";
import {
  uploadFile,
  uploadFileCloudinary,
  verifyUploadFileImageExtension,
} from "utils/utilities";
import MemoClose from "assets/icons/Close";
import MemoEditPen from "assets/icons/EditPen";
import { AddImageDescriptionModal } from "./AddImageDescriptionModal";

export const FileUpload = ({
  files,
  onUpload,
  onCross,
  isDesc,
  isAltText = true,
  onSubmitDescription,
  inputFormat,
  ext,
  isMultiple = true,
}) => {
  const [uploading, setUploading] = useState(false);
  const [isModalVisible, setModalVisible] = useState(false);

  const onFileUploadHandler = useCallback(
    (e) => {
      const count = e?.target?.files?.length || 0;
      setUploading(true);

      Promise.all(
        [...new Array(count)]?.map((_, i) => {
          const file = e.target.files?.[i];
          if (verifyUploadFileImageExtension(file, ext)) {
            // return uploadFile(file);
            return uploadFileCloudinary(file);
          } else {
            console.log(
              "Invalid extension found. Valid extensions are .png, .jpg, .jpeg"
            );
            return "";
          }
        })
      )
        .then((value) => {
          // const locations = value?.map((val) => val?.location);
          const locations = value?.map((val) => val?.secure_url);
          onUpload(locations);
        })
        .catch(console.error)
        .finally(() => setUploading(false));
    },
    [onUpload, ext]
  );

  return (
    <Box {...(uploading && { minHeight: "4rem" })}>
      <Box
        border="1px dashed"
        borderColor="neutral.400"
        p="2.4rem"
        borderRadius="1rem"
      >
        <Flex justifyContent="space-between">
          <Grid gridAutoFlow="column" gridGap="2rem">
            <Image src={UploadIcon} objectfit="contain" width="5rem" />
            <Box>
              <Text color="Black" mb="1rem" fontFamily="NeometricRegular">
                Select {isMultiple ? "Multiple" : ""} file
              </Text>
              <Text
                color="neutral.400"
                fontSize="1.4rem"
                fontFamily="NeometricRegular"
              >
                {ext
                  ? ext?.reduce(
                      (acc, pre) =>
                        acc?.toUpperCase() + pre?.toUpperCase() + ", ",
                      ""
                    )
                  : ""}
                JPG, JPEG, PNG file size no more than 10MB
              </Text>
            </Box>
          </Grid>
          <Button
            variant="primaryOutline"
            height="4.3rem"
            width="fit-content"
            px="3rem"
            type="button"
            as="label"
            loading={uploading}
            flex="none"
          >
            <input
              name="logo"
              type="file"
              noMargin
              disabled={uploading}
              style={{ display: "none" }}
              onChange={onFileUploadHandler}
              accept={`image/png, image/jpeg, image/jpg, image/svg+xml, ${inputFormat}`}
              {...(isMultiple && { multiple: true })}
            />
            Select File
          </Button>
        </Flex>
      </Box>

      {files?.length > 0 && (
        <Box>
          <Text fontSize="1.4rem" color="neutral.800" pt="1.6rem">
            Files added
          </Text>
          <Grid p="3rem" gridTemplateColumns="repeat(4, 1fr)" gridGap="1.6rem">
            {files?.map((file, index) => (
              <Box key={index}>
                <>
                  {/* Edit Button */}
                  {/* {isDesc && ( */}
                  {isAltText && (
                    <Flex
                      bg="primary.900"
                      color="white"
                      w="fit-content"
                      py="0.74rem"
                      px="0.72rem"
                      aI="center"
                      borderRadius="100%"
                      position="absolute"
                      top="1.3rem"
                      right="4.6rem"
                      cursor="pointer"
                      zIndex={1}
                      onClick={() =>
                        setModalVisible({ visible: true, old: file, index })
                      }
                    >
                      <MemoEditPen />
                    </Flex>
                  )}
                  {/* )} */}
                  {/* Close Button */}
                  <Flex
                    bg="secondary.900"
                    color="white"
                    w="fit-content"
                    py="0.74rem"
                    px="0.72rem"
                    aI="center"
                    borderRadius="100%"
                    position="absolute"
                    top="1.3rem"
                    right="1.3rem"
                    cursor="pointer"
                    zIndex={1}
                    onClick={() => onCross(index)}
                  >
                    <MemoClose />
                  </Flex>

                  {file?.image ? (
                    ["svg"]?.includes(
                      (file?.image || file)?.toString()?.split(".").pop()
                    ) ? (
                      <Image
                        src={file?.image || file}
                        // Revoke data uri after image is loaded
                        onLoad={() => {
                          URL.revokeObjectURL(file?.image || file);
                        }}
                        height="16rem"
                        // objectfit="cover"
                        css={{
                          "& img": {
                            borderRadius: "1rem",
                          },
                        }}
                      />
                    ) : (
                      <embed
                        width="160"
                        height="160"
                        style={{ borderRadius: "1rem" }}
                        onLoad={() => {
                          URL.revokeObjectURL(file?.image || file);
                        }}
                        // name="plugin"
                        src={file?.image || file}
                        // type="application/pdf"
                      ></embed>
                    )
                  ) : (
                    <Image
                      // Revoke data uri after image is loaded
                      onLoad={() => {
                        URL.revokeObjectURL(file?.image || file);
                      }}
                      height="16rem"
                      // objectfit="cover"
                      css={{
                        "& img": {
                          borderRadius: "1rem",
                        },
                      }}
                    />
                  )}
                </>
              </Box>
            ))}
          </Grid>
        </Box>
      )}
      <AddImageDescriptionModal
        isOpen={isModalVisible?.visible}
        onClose={() => setModalVisible(false)}
        loading={isModalVisible?.loading}
        error={isModalVisible?.error}
        preRecord={isModalVisible?.old}
        isDesc={isDesc}
        onSubmit={({ description, ...values }) => {
          setModalVisible((prev) => ({ ...prev, loading: true }));
          onSubmitDescription({
            description,
            file: { ...isModalVisible?.old, index: isModalVisible?.index },
            ...values,
          });
          setModalVisible(false);
        }}
      />
    </Box>
  );
};

// export const FileUpload = () => {
//   return (
//     <Box>
//       <section className="container">
//         <Box
//           border="1px dashed"
//           borderColor="neutral.400"
//           p="2.4rem"
//           borderRadius="1rem"
//           {...getRootProps({ className: "dropzone" })}
//         >
//           <input {...getInputProps()} />
//           <Flex justifyContent="space-between">
//             <Grid gridAutoFlow="column" gridGap="2rem">
//               <Image src={UploadIcon} objectfit="contain" width="5rem" />
//               <Box>
//                 <Text color="Black" mb="1rem" fontFamily="NeometricRegular">
//                   Select Multiple file or drag and drop here
//                 </Text>
//                 <Text
//                   color="neutral.400"
//                   fontSize="1.4rem"
//                   fontFamily="NeometricRegular"
//                 >
//                   JPG, PNG or PDF, file size no more than 10MB
//                 </Text>
//               </Box>
//             </Grid>
//             <Button
//               variant="primaryOutline"
//               height="4.3rem"
//               width="fit-content"
//               px="3rem"
//             >
//               Select File
//             </Button>
//           </Flex>
//         </Box>
//         {files.length > 0 && (
//           <Box>
//             <Text fontSize="1.4rem" color="neutral.800" pt="1.6rem">
//               Files added
//             </Text>
//             <Grid
//               p="3rem"
//               gridTemplateColumns="repeat(4, 1fr)"
//               gridGap="1.6rem"
//             >
//               {files.map((file, index) => (
//                 <Image
//                   key={index}
//                   src={file.preview}
//                   // Revoke data uri after image is loaded
//                   onLoad={() => {
//                     URL.revokeObjectURL(file.preview);
//                   }}
//                   height="16rem"
//                   objectfit="cover"
//                   borderRadius="1rem"
//                 />
//               ))}
//             </Grid>
//           </Box>
//         )}
//       </section>
//     </Box>
//   );
// };
